export const CHROME_WEB_STORE_URL = 'https://www.eluve.com/extension?redirect';
